var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1705,
    height: 1080,
    viewBox: "0 0 1705 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16,
    filter: "url(#filter0_f_67_1729)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 573.001,
    cy: 536.887,
    rx: 348.5,
    ry: 336.5,
    transform: "rotate(-8.41685 573.001 536.887)",
    fill: "url(#paint0_linear_67_1729)",
    fillOpacity: 0.72
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    filter: "url(#filter1_f_67_1729)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1085.69,
    cy: 770.688,
    r: 205,
    transform: "rotate(125.206 1085.69 770.688)",
    fill: "url(#paint1_linear_67_1729)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    filter: "url(#filter2_f_67_1729)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1255.48,
    cy: 536.868,
    r: 205,
    transform: "rotate(27.5862 1255.48 536.868)",
    fill: "url(#paint2_linear_67_1729)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_67_1729",
    x: 0.709656,
    y: -23.9218,
    width: 1144.58,
    height: 1121.62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112,
    result: "effect1_foregroundBlur_67_1729"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_67_1729",
    x: 676.671,
    y: 361.671,
    width: 818.034,
    height: 818.034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 102,
    result: "effect1_foregroundBlur_67_1729"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_67_1729",
    x: 806.439,
    y: 87.8256,
    width: 898.084,
    height: 898.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 122,
    result: "effect1_foregroundBlur_67_1729"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67_1729",
    x1: 444.315,
    y1: 333.978,
    x2: 815.057,
    y2: 701.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#00BEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_67_1729",
    x1: 876.362,
    y1: 722.184,
    x2: 1239.09,
    y2: 957.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BEA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_67_1729",
    x1: 1295.89,
    y1: 252.455,
    x2: 1058.19,
    y2: 756.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BEA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogin);
export default __webpack_public_path__ + "static/media/bg-login.6d45414fe5b17e740448ac55172b21e4.svg";
export { ForwardRef as ReactComponent };